import { useState, useEffect, useContext } from 'react'
import { FiEdit } from 'react-icons/fi'
import { Link, useAsyncError } from 'react-router-dom'
import { addDoc, collection, getDoc, getDocs } from 'firebase/firestore'
import { toast } from 'react-toastify'

import { Header } from '../../components/Header'
import { Title } from '../../components/Title'
import { AuthContext } from '../../contexts/auth'
import { db } from '../../services/firebaseConnection'

import { Content } from './styles'

const listRefDiscipline = collection(db, "discipline")
const listRefSubject = collection(db, "subject")
const listRefOrganizer = collection(db, "organizer")
const listRefInstitution = collection(db, "institution")
const listRefProfession = collection(db, "profession")
const listRefProfessionalQualification = collection(db, "professionalQualification")
const listRefWorkspace = collection(db, "workspace")

export function RegisterQuestion2() {
  const { user } = useContext(AuthContext)

  const [question, setQuestion] = useState('')
  const [answer, setAnswer] = useState('')
  const [answerComment, setAnswerComment] = useState('')
  const [answerTrueFalse, setAnswerTrueFalse] = useState('')
  const [alternationAnswerTrueFalse, setAlternationAnswerTrueFalse] = useState('')
  const [totalAnswers, setTotalAnswers] = useState([])
  //console.log(totalAnswers)

  const [discipline, setDiscipline] = useState([])
  const [disciplineSaved, setDisciplineSaved] = useState('')
  const [subject, setSubject] = useState([])
  const [subjectSaved, setSubjectSaved] = useState('')
  const [year, setYear] = useState('')
  const [organizer, setOrganizer] = useState([])
  const [organizerSaved, setOrganizerSaved] = useState('')
  const [institution, setInstitution] = useState([])
  const [institutionSaved, setInstitutionSaved] = useState('')
  const [profession, setProfession] = useState([])
  const [professionSaved, setProfessionSaved] = useState('')
  const [professionalQualification, setProfessionalQualification] = useState([])
  const [professionalQualificationSaved, setProfessionalQualificationSaved] = useState('')
  const [difficulty, setDifficulty] = useState('')
  const [workspace, setWorkspace] = useState([])
  const [workspaceSaved, setWorkspaceSaved] = useState('')
  const [modality, setModality] = useState('')

  const [loadingDiscipline, setLoadingDiscipline] = useState(true)
  const [loadingSubject, setLoadingSubject] = useState(true)
  const [loadingOrganizer, setLoadingOrganizer] = useState(true)
  const [loadingInstitution, setLoadingInstitution] = useState(true)
  const [loadingProfession, setLoadingProfession] = useState(true)
  const [loadingProfessionalQualification, setLoadingProfessionalQualification] = useState(true)
  const [loadingWorkspace, setLoadingWorkspace] = useState(true)

  const [disciplineSelected, setDisciplineSelected] = useState(0)

  useEffect(() => {

    async function loadingSubject() {
      const querySnapshot = await getDocs(listRefSubject)
        .then((snapshot) => {
          const lista = [];

          snapshot.forEach((doc) => {
            const subjectData = doc.data();

            // Verifica se o documento está associado à disciplina desejada
            if (subjectData.discipline === disciplineSaved) {
              lista.push({
                id: doc.id,
                subject: subjectData.subject,
                discipline: subjectData.discipline
              });
            }
          });

          if (lista.length === 0) {
            setDiscipline([{ id: 1, subject: "Nenhuma disciplina encontrada para esta disciplina" }]);
            setLoadingDiscipline(false);
            return;
          }

          setSubject(lista);
          setLoadingSubject(false);
        })
        .catch((err) => {
          console.log(err);
          setSubject([{ id: 1, subject: "Algo de errado" }]);
          setLoadingSubject(false);
        });
    }

    loadingSubject()

  }, [disciplineSaved])

  useEffect(() => {
    async function loadingDiscipline() {
      const querySnapshot = await getDocs(listRefDiscipline)
        .then((snapshot) => {
          //console.log(snapshot.docs)

          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              discipline: doc.data().discipline
            })
          })

          //console.log(lista)

          if (snapshot.docs.size === 0) {
            setDiscipline([{ id: 1, discipline: "Algo de errado" }])
            setLoadingDiscipline(false)
            return
          }

          setDiscipline(lista)
          setLoadingDiscipline(false)
        })
        .catch((err) => {
          console.log(err)
          setDiscipline([{ id: 1, discipline: "Algo de errado" }])
          setLoadingDiscipline(false)
        })
    }

    loadingDiscipline()

    // async function loadingSubject() {
    //   const querySnapshot = await getDocs(listRefSubject)
    //     .then((snapshot) => {
    //       //console.log(snapshot.docs)

    //       let lista = []

    //       snapshot.forEach((doc) => {
    //         lista.push({
    //           id: doc.id,
    //           subject: doc.data().subject
    //         })
    //       })

    //       //console.log(lista)

    //       if (snapshot.docs.size === 0) {
    //         setDiscipline([{ id: 1, discipline: "Algo de errado" }])
    //         setLoadingDiscipline(false)
    //         return
    //       }

    //       setSubject(lista)
    //       setLoadingSubject(false)
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //       setSubject([{ id: 1, discipline: "Algo de errado" }])
    //       setLoadingSubject(false)
    //     })
    // }

    // loadingSubject()

    async function loadingOrganizer() {
      const querySnapshot = await getDocs(listRefOrganizer)
        .then((snapshot) => {
          //console.log(snapshot.docs)

          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              organizer: doc.data().organizer
            })
          })

          //console.log(lista)

          if (snapshot.docs.size === 0) {
            setOrganizer([{ id: 1, discipline: "Algo de errado" }])
            setLoadingOrganizer(false)
            return
          }

          setOrganizer(lista)
          setLoadingOrganizer(false)
        })
        .catch((err) => {
          console.log(err)
          setOrganizer([{ id: 1, discipline: "Algo de errado" }])
          setLoadingOrganizer(false)
        })
    }

    loadingOrganizer()

    async function loadingInstitution() {
      const querySnapshot = await getDocs(listRefInstitution)
        .then((snapshot) => {
          //console.log(snapshot.docs)

          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              institution: doc.data().institution
            })
          })

          //console.log(lista)

          if (snapshot.docs.size === 0) {
            setInstitution([{ id: 1, discipline: "Algo de errado" }])
            setLoadingInstitution(false)
            return
          }

          setInstitution(lista)
          setLoadingInstitution(false)
        })
        .catch((err) => {
          console.log(err)
          setInstitution([{ id: 1, discipline: "Algo de errado" }])
          setLoadingInstitution(false)
        })
    }

    loadingInstitution()

    async function loadingProfession() {
      const querySnapshot = await getDocs(listRefProfession)
        .then((snapshot) => {
          //console.log(snapshot.docs)

          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              profession: doc.data().profession
            })
          })

          //console.log(lista)

          if (snapshot.docs.size === 0) {
            setProfession([{ id: 1, discipline: "Algo de errado" }])
            setLoadingProfession(false)
            return
          }

          setProfession(lista)
          setLoadingProfession(false)
        })
        .catch((err) => {
          console.log(err)
          setProfession([{ id: 1, discipline: "Algo de errado" }])
          setLoadingProfession(false)
        })
    }

    loadingProfession()

    async function loadingProfessionalQualification() {
      const querySnapshot = await getDocs(listRefProfessionalQualification)
        .then((snapshot) => {
          //console.log(snapshot.docs)

          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              professionalQualification: doc.data().professionalQualification
            })
          })

          //console.log(lista)

          if (snapshot.docs.size === 0) {
            setProfessionalQualification([{ id: 1, discipline: "Algo de errado" }])
            setLoadingProfessionalQualification(false)
            return
          }

          setProfessionalQualification(lista)
          setLoadingProfessionalQualification(false)
        })
        .catch((err) => {
          console.log(err)
          setProfessionalQualification([{ id: 1, discipline: "Algo de errado" }])
          setLoadingProfessionalQualification(false)
        })
    }

    loadingProfessionalQualification()

    async function loadingWorkspace() {
      const querySnapshot = await getDocs(listRefWorkspace)
        .then((snapshot) => {
          //console.log(snapshot.docs)

          let lista = []

          snapshot.forEach((doc) => {
            lista.push({
              id: doc.id,
              workspace: doc.data().workspace
            })
          })

          //console.log(lista)

          if (snapshot.docs.size === 0) {
            setWorkspace([{ id: 1, discipline: "Algo de errado" }])
            setLoadingWorkspace(false)
            return
          }

          setWorkspace(lista)
          setLoadingWorkspace(false)
        })
        .catch((err) => {
          console.log(err)
          setWorkspace([{ id: 1, discipline: "Algo de errado" }])
          setLoadingWorkspace(false)
        })
    }

    loadingWorkspace()

  }, [])

  function handleChangeDiscipline(e) {
    //setDiscipline(e.target.value)
    setDisciplineSaved(discipline[e.target.value].discipline)
  }

  function handleChangeSubject(e) {
    //setDiscipline(e.target.value)
    setSubjectSaved(subject[e.target.value].subject)
  }

  function handleChangeYear(e) {
    //setDiscipline(e.target.value)
    setYear(e.target.value)
  }

  function handleChangeOrganizer(e) {
    //e.prevetDefault()
    setOrganizerSaved(organizer[e.target.value].organizer)
  }

  function handleChangeInstitution(e) {
    setInstitutionSaved(institution[e.target.value].institution)
  }

  function handleChangeProfession(e) {
    setProfessionSaved(profession[e.target.value].profession)
  }

  function handleChangeDifficulty(e) {
    setDifficulty(e.target.value)
  }

  function handleChangeProfessionalQualification(e) {
    setProfessionalQualificationSaved(professionalQualification[e.target.value].professionalQualification)
  }

  function handleChangeWorkspace(e) {
    setWorkspaceSaved(workspace[e.target.value].workspace)
  }

  function handleSalveQuestion(e) {
    e.preventDefault()

    if (!answer) {
      return toast.error("Escreva a pergunta corretamente")
    }

    const eachAnswer = {
      answer: answer,
      answerTrueFalse: answerTrueFalse
    }

    setTotalAnswers([...totalAnswers, eachAnswer])
    setAnswer('')
    setAnswerTrueFalse('')
    toast.success('Resposta cadastrada com sucesso!')
  }

  function handleChangeAnswer(e) {
    setAnswerTrueFalse(e.target.value)
    //console.log(e.target.value)
  }

  function handleChangeModality(e) {
    setModality(e.target.value)
  }



  async function handleRegisterQuestion(e) {
    e.preventDefault()

    console.log("QUESTION: ", answerTrueFalse)
    if (answerTrueFalse === 'verdadeiro') {
      setAlternationAnswerTrueFalse('falso')
    } else if (answerTrueFalse === 'falso') {
      setAlternationAnswerTrueFalse('verdadeiro')
    }

    if (question !== '') {
      await addDoc(collection(db, "questions"), {
        question: question,
        answerComment: answerComment,
        answerTrueFalse: answerTrueFalse,
        alternationAnswerTrueFalse: alternationAnswerTrueFalse,
        created: new Date(),
        discipline: disciplineSaved,
        subject: subjectSaved,
        year: year,
        organizer: organizerSaved,
        institution: institutionSaved,
        profession: professionSaved,
        difficulty: difficulty,
        professionalQualification: professionalQualificationSaved,
        workspace: workspaceSaved,
        modality: "Certo-errado",
      })
        .then(() => {
          setQuestion('')

          setAnswer('')
          setAnswerComment('')
          setAnswerTrueFalse('')

          toast.success("Questão e respostas salvas com sucesso")
        })
        .catch((err) => {
          console.log(err)
          toast.error("Erro ao cadastrar nova questão")
        })
    } else {
      toast.error("Algo de errado aconteceu, verifique e tente novamente")
    }

  }

  return (
    <>
      <Header />
      <Content>
        <Title name="Cadastrar Questão">
          <FiEdit size={25} />
        </Title>

        <div className='container'>

          <form onSubmit={handleRegisterQuestion}>
            <label>Categorias</label>
            <div className='box-categorys'>
              {
                loadingDiscipline ? (
                  <input type='text' disabled={true} value="Carregando..." />
                ) : (
                  <select onChange={handleChangeDiscipline} >
                    {discipline.map((item, index) => {
                      return (
                        <>
                          <option key={index} value={index} >

                            {item.discipline}
                          </option>
                        </>
                      )
                    })}
                  </select>
                )
              }
              {
                loadingSubject ? (
                  <input type='text' disabled={true} value="Carregando..." />
                ) : (
                  <select onChange={handleChangeSubject} >
                    {subject.map((item, index) => {
                      return (
                        <option key={index} value={index} >
                          {item.subject}
                        </option>
                      )
                    })}
                  </select>
                )
              }
              {
                loadingOrganizer ? (
                  <input type='text' disabled={true} value="Carregando..." />
                ) : (
                  <select onChange={handleChangeOrganizer} >
                    {organizer.map((item, index) => {
                      return (
                        <option key={index} value={index} >
                          {item.organizer}
                        </option>
                      )
                    })}
                  </select>
                )
              }

              {
                loadingInstitution ? (
                  <input type='text' disabled={true} value="Carregando..." />
                ) : (
                  <select onChange={handleChangeInstitution} >
                    {institution.map((item, index) => {
                      return (
                        <option key={index} value={index} >
                          {item.institution}
                        </option>
                      )
                    })}
                  </select>
                )
              }
              <select onChange={handleChangeYear}>
                <option>Selecione o Ano</option>
                <option value="2024">2024</option>
                <option value="2023">2023</option>
                <option value="2022">2022</option>
                <option value="2021">2021</option>
                <option value="2020">2020</option>
                <option value="2019">2019</option>
              </select>
              {
                loadingProfession ? (
                  <input type='text' disabled={true} value="Carregando..." />
                ) : (
                  <select onChange={handleChangeProfession} >
                    {profession.map((item, index) => {
                      return (
                        <option key={index} value={index} >
                          {item.profession}
                        </option>
                      )
                    })}
                  </select>
                )
              }
              <select onChange={handleChangeDifficulty}>
                <option>Selecione o Nível</option>
                <option value="Fundamental" >Fundamental</option>
                <option value="Medio" >Médio</option>
                <option value="Superior" >Superior</option>
              </select>
              {
                loadingProfessionalQualification ? (
                  <input type='text' disabled={true} value="Carregando..." />
                ) : (
                  <select onChange={handleChangeProfessionalQualification} >
                    {professionalQualification.map((item, index) => {
                      return (
                        <option key={index} value={index} >
                          {item.professionalQualification}
                        </option>
                      )
                    })}
                  </select>
                )
              }
              {
                loadingWorkspace ? (
                  <input type='text' disabled={true} value="Carregando..." />
                ) : (
                  <select onChange={handleChangeWorkspace} >
                    {workspace.map((item, index) => {
                      return (
                        <option key={index} value={index} >
                          {item.workspace}
                        </option>
                      )
                    })}
                  </select>
                )
              }
              {/* <select onChange={handleChangeModality}>
                <option>Selecione a Modalidade</option>
                <option value="Certo-errado" >Certo-Errado</option>
                <option value="Multipla-escolha" >Multipla Escolha</option>
              </select> */}
            </div>
            <div className='question-null'>
              <input type="checkbox" />
              <label>Questão Nula</label>
            </div>
            <label>Pergunta</label>
            <textarea
              type="text"
              placeholder="Escreva o enunciado da questão"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
            />
            <label>Comentário</label>
            <input
              type='text'
              placeholder='Escreva o comentario'
              value={answerComment}
              onChange={(e) => setAnswerComment(e.target.value)}
            />
            <label>Resposta</label>
            <div className='box-question-answer'>
              {/* <input
                placeholder='Escreva a resposta'
                type='text'
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
              /> */}
              <div className='box-answer'>
                <div className='answer'>
                  <label>Verdadeiro</label>
                  <input
                    type='radio'
                    name='radio'
                    id='verdadeiro'
                    value='verdadeiro'
                    onChange={handleChangeAnswer}
                    checked={answerTrueFalse === 'verdadeiro'}
                  />
                </div>
                <div className='answer'>
                  <label>Falso</label>
                  <input
                    type='radio'
                    name='radio'
                    id='falso'
                    value='falso'
                    onChange={handleChangeAnswer}
                    checked={answerTrueFalse === 'falso'}
                  />
                </div>
              </div>
            </div>
            <button type='submit' >Cadastrar </button>
          </form>
          {/* <button type='submit' onClick={handleRegisterQuestion} ></button> */}
          {/* <ul>
            <strong>Pergunstas e Respostas Salvas:</strong>
            {totalAnswers.map((i) => {
              //console.log(i)
              return (
                <>
                  <li>Perguntra: {i.answer}</li>
                  <i>Resposta: {i.answerTrueFalse}</i>
                </>
              )
            })}
          </ul> */}
        </div>


      </Content >
    </>
  )
}